import { FC } from 'react'
import s from './Place.module.sass'
import { Metro } from '@shared/ui/Feedback/Metro'
import { Text } from '@shared/ui/Typography/Text'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { TypeMappingRestMetroItem } from '@shared/api/middleware/mappingAPI/restaurant/type'

interface Props {
  metro?: TypeMappingRestMetroItem[]
  address: string
}

const Place: FC<Props> = ({ metro, address }) => {
  return metro || address ? (
    <BlockBoundary>
      {metro?.length > 0 ? (
        <ul className={s.metro}>
          {metro.map((item, index) => {
            const isShowStation = index < 2
            return isShowStation && <Metro key={item.name} name={item.name} link={item.url} colors={item.color} />
          })}
        </ul>
      ) : (
        <div className={s.metro}>
          <Text tag={'span'} sizes={'S'} className={s.address}>
            {address}
          </Text>
        </div>
      )}
    </BlockBoundary>
  ) : null
}

export default Place
